import { render, staticRenderFns } from "./DiyPhone.vue?vue&type=template&id=fc23a1c4&scoped=true"
import script from "./DiyPhone.vue?vue&type=script&lang=js"
export * from "./DiyPhone.vue?vue&type=script&lang=js"
import style0 from "./DiyPhone.vue?vue&type=style&index=0&id=fc23a1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc23a1c4",
  null
  
)

export default component.exports